import { Builder } from '@builder.io/react';
import React, { useEffect, useRef, useState } from 'react';
import { selectProducts } from '../../../../../../store/products';
import { useSelector } from 'react-redux';
// import QurbanWidgetContent from '../../../../../general/qurbanWidget/qurbanWidgetContent';
import QurbanTabContent from '../../../../../general/qurbanWidget2/tab-content';
import CustomButton from '../../../../../general/button';
import { useNavigate } from 'react-router-dom';
import ProductsTabVertical from '../../../../../general/productsTabVertical';
// import masjidPhoto from '../../images/home/general-masjid.jpg';
import AppealWidgetNewWithCarousel from '../../../../../../pages/MATWAppeal/components/appealWidgetNewWithCarousel';
import { checkDomain } from '../../../../../../utils/checkDomain';
import { calculateCampaigns } from '../../../../../../pages/MATWAppeal/campaignCalculation';
import { getCreatorCodesWithDates } from '../../../../../../pages/MATWAppeal/dates';
import { selectSelectedCurrency } from '../../../../../../store/user';
import bringRamadanImg from '../../../../../../images/ramadan/Bring Ramadan to Gaza Appeal.jpg';
import orphansOfUmmahImage from '../../../../../../images/orphans/orphans-of-ummah-box-image.jpg';


import services from '../../../../../../services';

const ProductsTabsVertical = props => {
  const tabs = props.sections || [];
  const selectedCurrencyStore = useSelector(selectSelectedCurrency);

  // console.log("propsss===",props)
  const [isLoaded, setIsLoaded] = useState(false);
  const contentRef = useRef(null);
  const visibleTabs = tabs.filter(tab => tab.isTabsVisible !== false);
  const [activeTabProducts, setActiveTabProducts] = useState(0);
  const [tabTopProducts, setTabTopProducts] = useState([]);
  const [tabBottomeProducts, setTabBottomeProducts] = useState([]);
  const [extraTabProducts, setExtraTabProducts] = useState([]);

  const [topCardProduct, setTopCardProduct] = useState([]);
  const [secondCardProduct, setSecondCardProduct] = useState([]);
  const [limitedProduct, setLimitedProduct] = useState([]);
  // ← new: per-tab category→products
  const [tabCategoryProducts, setTabCategoryProducts] = useState([]);
  // ← new: which category is selected within the active tab
  const [selectedCategoryKey, setSelectedCategoryKey] = useState(tabs[0]?.categories?.[0]?.key || '');
  // const navigate = useNavigate();
  const [sadaqahProducts, setSadaqahProducts] = useState([0, 0, 0, 0, 0, 0]);
  const [topAppealsProducts, setTopAppealsProducts] = useState([0, 0, 0, 0]);
  // const [foodAidProducts, setFoodAidProducts] = useState([0, 0, 0, 0]);
  const [mostNeededProducts, setMostNeededProducts] = useState([0, 0, 0, 0, 0, 0]);
  const [zakatProducts, setZakatProducts] = useState([0, 0]);
  // const [orphansProducts, setOrphansProducts] = useState([0, 0]);
  const [waterWellProducts, setWaterWellProducts] = useState([0, 0, 0, 0, 0, 0]);
  // const [palestineEmergencyProducts, setPalestineEmergencyProducts] = useState([0, 0, 0, 0]);
  const [urgentAppealProducts, setUrgentAppealProducts] = useState([0, 0, 0, 0, 0]);
  const [urgentAppealProducts2, setUrgentAppealProducts2] = useState([0, 0, 0, 0, 0]);
  const [qurbanProducts, setQurbanProducts] = useState([0, 0, 0, 0, 0, 0, 0, 0, 0, 0]);
  const [allOrders, setAllOrders] = useState([]);

  const [selectedCurrency, setSelectedCurrency] = useState();

  const products = useSelector(state => selectProducts(state));
  console.log(products, 'products from redux');
  const navigate = useNavigate();

  const getAllProducts = () => {
    setIsLoaded(true);
    let tempSadaqahProducts = [];
    let tempFoodAidProducts = [];
    let tempZakateProducts = [];
    let tempOrphansProducts = [];
    let tempFeedOrphansProducts = [];
    let tempTopAppealsProducts = [];
    let tempBasicWaterWellProducts = [];
    let tempWaterWellProducts = [];
    let tempIftarMealsProducts = [];
    let tempMostNeededProducts = [];
    // let tempPalestineEmergencyProducts = [];
    // let gazaFamilyShelterKitProduct = null;
    let tempFeed40OrphanProduct = null;
    let tempRamadanWhereMostNeededProducts = [];
    let tempGazaWaterProducts = [];
    let tempQurbanProducts = [];
    // let tempPalestineWaterPiplineProduct = null
    products?.map(item => {
      item.sub_categories.map(inner_item => {
        inner_item.products.map(inner_item_product => {
          if (inner_item_product.creator === 'QB-25-022') tempQurbanProducts[0] = inner_item_product;
          if (inner_item_product.creator === 'QB-25-001') tempQurbanProducts[1] = inner_item_product;
          if (inner_item_product.creator === 'QB-25-002') tempQurbanProducts[2] = inner_item_product;
          if (inner_item_product.creator === 'QB-25-003') tempQurbanProducts[3] = inner_item_product;
          if (inner_item_product.creator === 'QB-25-007') tempQurbanProducts[4] = inner_item_product;
          if (inner_item_product.creator === 'TXT-QB-25-024') tempQurbanProducts[5] = inner_item_product;
          if (inner_item_product.creator === 'TXT-QB-25-025') tempQurbanProducts[6] = inner_item_product;
          if (inner_item_product.creator === 'TXT-QB-25-026') tempQurbanProducts[7] = inner_item_product;
          if (inner_item_product.creator === 'TXT-QB-25-027') tempQurbanProducts[8] = inner_item_product;
          if (inner_item_product.creator === 'TXT-QB-25-028') tempQurbanProducts[9] = inner_item_product;
          if (inner_item_product.creator === 'EMR-PAL-25-020') tempGazaWaterProducts[0] = inner_item_product;
          if (inner_item_product.creator === 'EMR-PAL-25-022') tempGazaWaterProducts[1] = inner_item_product;
          if (inner_item_product.creator === 'ZK-PAL-25-01') tempRamadanWhereMostNeededProducts[0] = inner_item_product;
          if (inner_item_product.creator === 'TXT-RM25-00-04') tempRamadanWhereMostNeededProducts[1] = inner_item_product;
          if (inner_item_product.creator === 'TXT-RM25-00-02') tempRamadanWhereMostNeededProducts[2] = inner_item_product;
          if (inner_item_product.creator === 'RM25-00-019') tempRamadanWhereMostNeededProducts[3] = inner_item_product;
          if (inner_item_product.creator === 'RM25-00-000') tempRamadanWhereMostNeededProducts[4] = inner_item_product;
          if (inner_item_product.creator === 'RM25-00-016') tempRamadanWhereMostNeededProducts[5] = inner_item_product;
          if (inner_item_product.creator === 'RM25-00-013') tempRamadanWhereMostNeededProducts[6] = inner_item_product;
          if (inner_item_product.creator === 'EMR-PAL-25-017') tempMostNeededProducts[0] = inner_item_product;
          if (inner_item_product.creator === 'EMR-PAL-25-014') tempMostNeededProducts[1] = inner_item_product;
          if (inner_item_product.creator === 'EMR-PAL-25-016') tempMostNeededProducts[2] = inner_item_product;
          if (inner_item_product.creator === 'EMR-PAL-25-015') tempMostNeededProducts[3] = inner_item_product;
          if (inner_item_product.creator === 'EMR-PAL-25-020') tempMostNeededProducts[4] = inner_item_product;
          if (inner_item_product.creator === 'EMR-PAL-25-022') tempMostNeededProducts[5] = inner_item_product;
          if (inner_item_product.creator === 'EMR-PAL-GEN-24-11-1') {
            urgentAppealProducts[2] = inner_item_product;
          }
          if (inner_item_product.creator === 'EMR-DIS-PSE-2023-01' && checkDomain('matwprojectusa.org', 'matwproject.org.uk', 'matwproject.org')) {
            urgentAppealProducts[1] = inner_item_product;
          }
          if (inner_item_product.creator === 'EMR-LEB-24-000') {
            const index = checkDomain('matwprojectusa.org', 'matwproject.org.uk', 'matwproject.org') ? 3 : 5;
            urgentAppealProducts[index] = inner_item_product;
          }
          if (inner_item_product.creator === 'MKD-MN-001' && checkDomain('matwproject.org.uk', 'matwproject.org')) {
            urgentAppealProducts[4] = inner_item_product;
          }
          if (inner_item_product.creator === 'AO-EMR-WNT-GEN-24-06' && !checkDomain('matwproject.org.uk', 'matwproject.org')) {
            const index = checkDomain('matwprojectusa.org') ? 4 : 3;
            urgentAppealProducts[index] = inner_item_product;
          }
          if (inner_item_product.creator === 'MA-PAL-GL-1-001' && checkDomain('matwprojectusa.org')) {
            urgentAppealProducts[5] = inner_item_product;
          }

          if (inner_item_product.creator === 'EMR-DIS-PSE-2023-01-01' && checkDomain('matwproject.org.uk')) {
            urgentAppealProducts[5] = inner_item_product;
          }
          if (inner_item_product.creator === 'AO-EMR-WNT-GEN-24-06' && checkDomain('matwproject.org')) {
            urgentAppealProducts[5] = inner_item_product;
          }
          if (inner_item_product.creator === 'RM25-00-019') {
            // urgentAppealProducts[8] = inner_item_product;
            tempFeed40OrphanProduct = inner_item_product;
          }
          if (inner_item_product.creator === 'GD-MP015' && !checkDomain('matwprojectfr.org')) {
            // Subscription Tab Starts
            // General Masjid
            inner_item_product = Object.assign({}, inner_item_product, {
              subTitle:
                'Millions of people in underserved communities around the world don’t have access to a Mosque or Masjid. MATW wishes to change that. We believe that everybody should have access to a place of worship that serves as a hub for their community.',
              subTitleCopy:
                'Millions of people in underserved communities around the world don’t have access to a Mosque or Masjid. MATW wishes to change that. We believe that everybody should have access to a place of worship that serves as a hub for their community.',
              image_link: 'masjidPhoto',
              navigationLink: '/sadaqah-jariyah/build-a-masjid',
            });
            tempSadaqahProducts[0] = inner_item_product;
          }

          if (inner_item_product.creator === 'MKD-WEL-SDQ-2023-01') {
            // Water Well
            inner_item_product = Object.assign({}, inner_item_product, {
              alternativeName: 'Water Wells',
              subTitle:
                'Every year, 3.5 million people lose their lives due to water-related diseases, of which 2.2 million are children. We can make a difference in these lives by providing them with a source of clean water.',
              subTitleCopy:
                'Every year, 3.5 million people lose their lives due to water-related diseases, of which 2.2 million are children. We can make a difference in these lives by providing them with a source of clean water.',
              image_link: 'waterWellSubPhoto',
              navigationLink: '/sadaqah-jariyah/build-a-water-well',
            });
            tempSadaqahProducts[1] = inner_item_product;
          }

          if (inner_item_product.creator === 'MKD-GEN-MOR-2023-01-119') {
            // Food and Water Distribution
            inner_item_product = Object.assign({}, inner_item_product, {
              alternativeName: 'ORPHANS',
              subTitle:
                'Almost 5,700 children are orphaned every day due to war, natural disasters, poverty, and diseases. Whatever the cause, many of these children are alone and vulnerable. Help us give them a fighting chance at a brighter future.',
              subTitleCopy:
                'Almost 5,700 children are orphaned every day due to war, natural disasters, poverty, and diseases. Whatever the cause, many of these children are alone and vulnerable. Help us give them a fighting chance at a brighter future.',
              image_link: 'orphansSubPhoto',
              navigationLink: '/orphans',
            });
            tempSadaqahProducts[2] = inner_item_product;
          }

          if (inner_item_product.creator === 'MKD-GEN-MPN-2023-01-124') {
            // Sadaqah Jariyah
            inner_item_product = Object.assign({}, inner_item_product, {
              alternativeName: 'Project Noor',
              subTitle: `Our Muslims Around The World team has been hard at work in Bangladesh, Indonesia and Pakistan restoring sight for vulnerable people living in impoverished communities. By giving this Sadaqah Jariyah, you’re changing lives. Help us give the gift of sight.`,
              subTitleCopy:
                'Our Muslims Around The World team has been hard at work in Bangladesh, Indonesia and Pakistan restoring sight for vulnerable people living in impoverished communities. By giving this Sadaqah Jariyah, you’re changing lives. Help us give the gift of sight.',
              status: '1',
              image_link: 'projNoorSubPhoto',
              navigationLink: '/sadaqah-jariyah/emergency',
            });
            tempSadaqahProducts[3] = inner_item_product;
          }
          // Subscription Tab Ends

          // Start Top Appeals
          // if (inner_item_product.creator === 'EMR-DIS-PSE-2023-01') tempTopAppealsProducts[0] = inner_item_product
          // if (inner_item_product.creator === 'GD-MP015') tempTopAppealsProducts[1] = inner_item_product
          // if (inner_item_product.creator === 'EMR-DIS-BFPL-2024-01-207') tempTopAppealsProducts[3] = inner_item_product
          if (inner_item_product.creator === 'EMR-DIS-PSE-2023-01') {
            inner_item_product = Object.assign({}, inner_item_product, {
              alt: 'Muslim Charity to help palestine',
            });
            tempTopAppealsProducts[0] = inner_item_product;
          }
          if (inner_item_product.creator === 'GD-MP015' && !checkDomain('matwprojectfr.org')) {
            inner_item_product = Object.assign({}, inner_item_product, {
              alt: 'Islamic Charity: donate to build Masjids',
            });
            tempTopAppealsProducts[1] = inner_item_product;
          }
          if (inner_item_product.creator === 'EMR-DIS-BFPL-2024-01-207') {
            inner_item_product = Object.assign({}, inner_item_product, {
              alt: 'Muslim Charity to help palestinian refugees',
            });
            tempTopAppealsProducts[3] = inner_item_product;
          }

          if (inner_item_product.creator === 'WWC-CON-BBW-2023-01-029') tempBasicWaterWellProducts[0] = inner_item_product;
          if (inner_item_product.creator === 'WWC-CON-PBW-2023-01-030') tempBasicWaterWellProducts[1] = inner_item_product;
          if (inner_item_product.creator === 'WWC-CON-IBW-2023-01-031') tempBasicWaterWellProducts[2] = inner_item_product;
          if (inner_item_product.creator === 'WWC-CON-ABW-2023-01-028') tempBasicWaterWellProducts[3] = inner_item_product;
          // End Top Appeals

          // Start Food Aid
          if (inner_item_product.creator === 'RM24-FA-010') {
            inner_item_product = Object.assign({}, inner_item_product, {
              isStaticProduct: true,
              staticLink: '/ramadan/fidya-kaffarah?product=kafarrah',
              staticLinkText: 'CALCULATE YOUR KAFFARAH',
              // linkBtnClasses: 'lg:!text-base !font-normal'
            });
            tempFoodAidProducts[2] = inner_item_product;
          }
          if (inner_item_product.creator === 'RM24-FA-011') {
            inner_item_product = Object.assign({}, inner_item_product, {
              isStaticProduct: true,
              staticLink: '/ramadan/fidya-kaffarah?product=fidya',
              staticLinkText: 'CALCULATE YOUR FIDYA',
              // linkBtnClasses: 'lg:!text-base !font-normal'
            });
            tempFoodAidProducts[3] = inner_item_product;
          }

          // End Food Aid

          // Start Zakat
          if (inner_item_product.creator === 'RM24-ZM-013') {
            inner_item_product = Object.assign({}, inner_item_product, {
              isStaticProduct: true,
              staticLink: '/zakat',
              staticLinkText: 'GIVE ZAKAT AL MAL',
              short_description:
                'Zakat is an obligatory charity given annually by every able muslim, purifying their wealth and earning rewards from Allah SWT.',
            });
            tempZakateProducts[1] = inner_item_product;
            tempZakateProducts[0] = Object.assign({}, inner_item_product, {
              alternativeName: 'ZAKAT CALCULATOR',
              image_link: '/images/zakat/zakat-cal.jpg',
              isStaticProduct: true,
              staticLink: '/zakat-calculator',
              staticLinkText: 'CALCULATE YOUR ZAKAT',
              short_description: 'Use our Zakat calculator to calculate how much you must give in Zakat annually.',
              // linkBtnClasses: 'lg:!text-base !font-normal'
            });
          }
          // End Zakat

          // Start Orphan
          if (inner_item_product.creator === 'RM24-OP-014') tempOrphansProducts[1] = inner_item_product;
          // End Orphan

          // Start Water well
          if (inner_item_product.creator === 'WWC-CON-BBW-2023-01-029') tempWaterWellProducts[0] = inner_item_product;
          if (inner_item_product.creator === 'WWC-CON-ABW-23-01-028') tempWaterWellProducts[1] = inner_item_product;
          if (inner_item_product.creator === 'MSJ-WA-SMJ-2023-01') tempWaterWellProducts[2] = inner_item_product;
          if (inner_item_product.creator === 'WWC-CON-L1W-2023-01-026') tempWaterWellProducts[3] = inner_item_product;
          if (inner_item_product.creator === 'WWC-CON-L2W-2023-01-027') tempWaterWellProducts[4] = inner_item_product;
          if (inner_item_product.creator === 'MSJ-CON-IMJ-2023-01-014') tempWaterWellProducts[5] = inner_item_product;
          // End Water well

          // palestineEmergencyProducts
          // if (inner_item_product.creator === 'EMR-DIS-PSE-2023-01') {
          //   // inner_item_product = Object.assign({}, inner_item_product, {
          //   //   alternativeName: 'PALESTINE APPEAL',
          //   // });
          //   tempPalestineEmergencyProducts[0] = inner_item_product;
          // }
          // if (inner_item_product.creator === 'EMR-DIS-PSE-2023-01-01') {
          //   tempPalestineEmergencyProducts[1] = inner_item_product;
          // }
          // if (inner_item_product.creator === 'EMR-DIS-BFPL-2023-01-102') {
          //   tempPalestineEmergencyProducts[2] = inner_item_product;
          // }
          // if (inner_item_product.creator === 'EMR-DIS-BFPL-2023-01-204') {
          //   tempPalestineEmergencyProducts[3] = inner_item_product;
          // }
          // if (inner_item_product.creator === 'EMR-PAL-PW-2025-001') tempPalestineWaterPiplineProduct = inner_item_product;

          return inner_item_product;
        });
        return inner_item;
      });
      return item;
    });
    // tempTopAppealsProducts[2] = basicWaterWellProducts;
    // tempTopAppealsProducts[2].products = tempBasicWaterWellProducts;
    // tempFoodAidProducts[0] = iftarMealsProducts;
    // tempFoodAidProducts[0].products = tempIftarMealsProducts;
    // tempOrphansProducts[0] = feedOrphanProducts;
    // tempOrphansProducts[0].products = tempFeedOrphansProducts;

    // tempSadaqahProducts = tempSadaqahProducts.filter(n => n);
    // tempTopAppealsProducts = tempTopAppealsProducts.filter(n => n);
    // tempMostNeededProducts = tempMostNeededProducts.filter(n => n);
    // tempFoodAidProducts = tempFoodAidProducts.filter(n => n);
    // tempZakateProducts = tempZakateProducts.filter(n => n);
    // tempOrphansProducts = tempOrphansProducts.filter(n => n);
    // tempWaterWellProducts = tempWaterWellProducts.filter(n => n);
    // tempQurbanProducts = tempQurbanProducts.filter(n => n);
    // tempPalestineEmergencyProducts = tempPalestineEmergencyProducts.filter(n => n);
    // tempRamadanWhereMostNeededProducts = tempRamadanWhereMostNeededProducts.filter(n => n);
    // tempGazaWaterProducts = tempGazaWaterProducts.filter(n => n);

    setSadaqahProducts(tempSadaqahProducts);
    // setIftarProducts(tempIftarProducts);
    // setFeedOrphanProducts(tempFeedOrphansProducts);
    tempFeed40OrphanProduct && urgentAppealProducts.unshift(tempFeed40OrphanProduct);
    // tempFeed40OrphanProduct && urgentAppealProducts.push(tempFeed40OrphanProduct)
    setUrgentAppealProducts([...urgentAppealProducts]);
    setTopAppealsProducts(tempTopAppealsProducts);
    // setFoodAidProducts(tempFoodAidProducts);
    setMostNeededProducts(tempMostNeededProducts);
    setZakatProducts(tempZakateProducts);
    setQurbanProducts(tempQurbanProducts);
    // setOrphansProducts(tempOrphansProducts);
    setWaterWellProducts(tempWaterWellProducts);
    // setPalestineEmergencyProducts(tempPalestineEmergencyProducts);
    // setRamadanWhereMostNeededProducts(tempRamadanWhereMostNeededProducts);

    setUrgentAppealProducts2(prev => {
      let updated = [...prev]; // Create a new array copy
      // updated[2] = tempGazaWaterProducts[0];
      // updated[3] = tempGazaWaterProducts[1];
      return updated;
    });
  };
  const getLatestOrdersVersion3 = async () => {
    let req = {
      products: getCreatorCodesWithDates(),
      currency: selectedCurrencyStore,
    };
    try {
      const response = await services.getLatestOrdersV3(req);
      setAllOrders(response.data);
    } catch (error) {
      console.error('error========', error);
    }
  };
  const handleAppeals = () => {
    // let ramadanAppealPrd = {
    //   name: "Ramadan Appeal",
    //   description: "This Ramadan, light up the lives of those in need. Your generous donations will provide iftars for families, nourishing food packs for the needy, comforting hot meals for orphans, and heartfelt Zakat for the most vulnerable. Together, we can spread the true essence of compassion",
    //   status: 1,
    //   isStaticProduct: true,
    //   staticLink: '/ramadan',
    //   image_link: ramadanAppaelImg,
    //   staticLinkText: 'Donate Now'
    // }
    let bringRamadanPrd = {
      name: "Allah Sees Gaza, Do You?",
      description: " As the conflict in Gaza continues to escalate, so too does the damage, loss, destruction, and displacement that has become the harsh reality for countless families",
      status: 1,
      isStaticProduct: true,
      staticLink: '/crisis-and-emergencies/palestine',
      image_link: bringRamadanImg,
      staticLinkText: 'Donate Now'
    }

    let QurbanAppealPrd = {
      name: "Qurban",
      description: "If this was the last Qurban you ever gave — what would you want it to mean? Would you want it to be a ticked box, or a legacy of mercy?",
      status: 1,
      isStaticProduct: true,
      staticLink: '/qurban',
      image_link: 'https://cdn.builder.io/api/v1/image/assets%2F32b8c354d4bc455dbf10fed3923dfae1%2F173738410d3a458d98281a33c4dd885c',
      staticLinkText: 'Donate Now'
    }

    let orphansOfUmmahPrd = {
      name: "Orphans of the Ummah",
      description: "Give hope where it’s needed most. Your donation provides vulnerable orphans with food, shelter, education, and care.",
      status: 1,
      isStaticProduct: true,
      staticLink: '/orphans-of-ummah',
      image_link: orphansOfUmmahImage,
      staticLinkText: 'Donate Now'
    }
    
    if (!checkDomain('matwproject.org')) {
      QurbanAppealPrd.name = 'Qurbani'
      // Replace all occurrences in the description:
      QurbanAppealPrd.description = QurbanAppealPrd.description.replace(/Qurban/g, 'Qurbani')
      // (optional) update the URL too:
      QurbanAppealPrd.staticLink = '/qurbani'
    }
    const {
      appealProducts,
    } = calculateCampaigns({
      products: [],
      _prds: allOrders,
      selectedCurrencyStore,
      campaign: '',
      showAllAppeals: true
    });
    console.log("all orders appeals=",  appealProducts)
    setUrgentAppealProducts2(prev => {
      const updated = [...prev]; // Create a new array copy
      // updated[0] = QurbanAppealPrd;
      updated[0] = bringRamadanPrd;
      // updated[1] = ramadanAppealPrd;
      updated[1] = appealProducts.find(p => p.campaign === 'gaza-camp');
      updated[2] = orphansOfUmmahPrd;
      updated[3] = appealProducts.find(p => p.campaign === 'palestine');
      updated[4] = appealProducts.find(p => p.campaign === 'gaza-babies');
      // updated[4] = appealProducts.find(p => p.campaign === 'gaza-bakery');
      // updated[5] = appealProducts.find(p => p.campaign === 'palestine-water-pipeline');
      updated[5] = appealProducts.find(p => p.campaign === 'limbs-of-hope');
      return updated;
    });
  }
  useEffect(() => {
    selectedCurrencyStore ? setSelectedCurrency(selectedCurrencyStore) : setSelectedCurrency('AUD');
    if (selectedCurrencyStore) {
      getLatestOrdersVersion3();
      // getLatestOrders(selectedCurrencyStore);
      // getLatestOrdersForPalestineWaterPiplien(selectedCurrencyStore);
    } else {
      // getLatestOrders('AUD');
    }
    // getOrders(selectedCurrencyStore)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedCurrencyStore]);
  useEffect(() => {
    if (allOrders?.data?.length) {
      handleAppeals();
    }
    // allOrders.length && handleAppeals();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allOrders]);
  useEffect(() => {
    products && Object.keys(products).length && !isLoaded && getAllProducts();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [products]);

  const isNotUKDomain = window.location.hostname !== 'matwproject.org.uk';
  const isUKDomain = window.location.hostname === 'matwproject.org.uk' || window.location.hostname === 'yasir-uat.matwproject.org';
  // const term = checkDomain('matwproject.org') ? 'Qurban' : 'Qurbani'
  /* -------------------------------------------------------------------------- */
  const allProductsTab = [
    // {
    //   title: 'Gaza Ramadan Appeal',
    //   products: <AppealWidgetNewWithCarousel className="bg-transparent !py-0" allProducts={ramadanWhereMostNeededProducts.filter(i => !!i || i === 0)} isHomePage />,
    //   description: '',
    //   isCarousel: true
    // },
    
    isUKDomain
      ? {
        title: 'Give Your Zakat to Gaza',
        products: <AppealWidgetNewWithCarousel className="bg-transparent !py-0" allProducts={zakatProducts.filter(i => !!i || i === 0)} isHomePage />,
        description: 'Every year, we are given a profound opportunity to seek the pleasure of Allah SWT. This is a moment to make a meaningful impact, fulfill our duty, and embrace the immense rewards promised by Him. Let’s not let this chance pass us by.',
        isCarousel: true
      }
      : {
        title: 'urgent appeals',
        products: <AppealWidgetNewWithCarousel className="bg-transparent !py-0" allProducts={urgentAppealProducts2.filter(i => !!i || i === 0)} isHomePage />,
        description: '',
        isCarousel: true
      },
    
    isUKDomain
      ? {
        title: 'urgent appeals',
        products: <AppealWidgetNewWithCarousel className="bg-transparent !py-0" allProducts={urgentAppealProducts2.filter(i => !!i || i === 0)} isHomePage />,
        description: '',
        isCarousel: true
      }
      : {
        title: 'Most Needed',
        products: <AppealWidgetNewWithCarousel className="bg-transparent !py-0" allProducts={mostNeededProducts.filter(i => !!i || i === 0)} isHomePage />,
        description: '',
        isCarousel: true
      },
   isUKDomain
    ? {
      title: 'Most Needed',
      products: <AppealWidgetNewWithCarousel className="bg-transparent !py-0" allProducts={mostNeededProducts.filter(i => !!i || i === 0)} isHomePage />,
      description: '',
      isCarousel: true
    }:
    {
      title: 'Give Your Zakat to Gaza',
      products: <AppealWidgetNewWithCarousel className="bg-transparent !py-0" allProducts={zakatProducts.filter(i => !!i || i === 0)} isHomePage />,
      description: 'Every year, we are given a profound opportunity to seek the pleasure of Allah SWT. This is a moment to make a meaningful impact, fulfill our duty, and embrace the immense rewards promised by Him. Let’s not let this chance pass us by.',
      isCarousel: true
    },




    {
      title: 'Give the Ultimate Sadaqah Jariyah',
      // products: <AppealWidgetNewWithCarousel className="bg-transparent !py-0" allProducts={waterWellProducts.filter(i => !!i || i === 0)} isHomePage />,
      products: <AppealWidgetNewWithCarousel className="bg-transparent !py-0" allProducts={waterWellProducts.filter(i => !!i || i === 0)} isHomePage />,
      description: 'Give the ultimate Sadaqah Jariyah by building a water well.',
      isCarousel: true
    },
 
  ];

  return (
    <ProductsTabVertical
      sections={allProductsTab}
      // selectedCurrency={selectedCurrency}
    />
  );
};

Builder.registerComponent(ProductsTabsVertical, {
  name: 'ProductsTabsVerticalV1',
});
export default ProductsTabsVertical;
